import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';

import { useFelaEnhanced } from '@ackee/fela';

import { ModalType } from './ModalType';
import { ModalContainerBasedOnType } from './ModalContainerBasedOnType';

import * as felaRules from './Modal.rules';

interface ModalProps {
    children: Dialog.DialogProps['children'];
    open: Dialog.DialogProps['open'];
    onOpenChange: Dialog.DialogProps['onOpenChange'];
    grid?: boolean;
    type?: ModalType;
    title?: string;
}

export const Modal = ({
    children = null,
    onOpenChange,
    open = false,
    grid = false,
    type = ModalType.huge,
    title,
}: ModalProps) => {
    const { styles } = useFelaEnhanced(felaRules, { type, open });
    return (
        <Dialog.Root open={open} onOpenChange={onOpenChange}>
            <Dialog.Portal>
                <Dialog.Overlay className={styles.overlay}>
                    <Dialog.Content className={styles.content}>
                        <ModalContainerBasedOnType type={type} grid={grid} title={title}>
                            {children}
                        </ModalContainerBasedOnType>
                    </Dialog.Content>
                </Dialog.Overlay>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
